export default __webpack_public_path__ + "static/media/1637.60ecd0cc.png";